// const CHANGE_VALUES = 'mrDistribution/CHANGE_VALUES';
const SET_SHIPMENT_KEYS = 'mrDistribution/SET_SHIPMENT_KEYS';

const changeTime$ = 'mrDistribution/changeTime$';
const selectTime$ = 'mrDistribution/selectTime$';
const onBlurTimePicker$ = 'mrDistribution/onBlurTimePicker$';

const changeDate$ = 'mrDistribution/changeDate$';

const changeAddress$ = 'mrDistribution/changeAddress$';
const cleanAddress$ = 'mrDistribution/cleanAddress$';

const createShipment$ = 'mrDistribution/createShipment$';
const ADD_SHIPMENT = 'mrDistribution/ADD_SHIPMENT';
const REMOVE_SHIPMENT = 'mrDistribution/REMOVE_SHIPMENT';

export default {
  // CHANGE_VALUES,
  SET_SHIPMENT_KEYS,

  changeTime$,
  selectTime$,
  onBlurTimePicker$,

  changeDate$,

  changeAddress$,
  cleanAddress$,

  createShipment$,
  ADD_SHIPMENT,
  REMOVE_SHIPMENT,
};
